import { render } from "./LeadDetail.vue?vue&type=template&id=eddc12b2&scoped=true"
import script from "./LeadDetail.vue?vue&type=script&lang=js"
export * from "./LeadDetail.vue?vue&type=script&lang=js"

import "./LeadDetail.vue?vue&type=style&index=0&id=eddc12b2&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_omnia_1764364323178277687/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eddc12b2"]])

export default __exports__